/* DC.SPORTS — Refonte : menu immersif sur-mesure + enhancements (par-dessus Speedfly).
   Ne modifie aucune fonction du thème (panier/upsell/paiement). Réutilise les liens existants. */
(function () {
  'use strict';

  /* ====== Données du menu (issues de la navigation Shopify "menu") ====== */
  var MENU = [
    { l: 'RAQUETTES', u: '/collections/raquettes-de-badminton', groups: [
      { t: 'PAR MARQUE', links: [
        { l: 'Yonex', u: '/collections/raquettes-de-badminton/Yonex+Raquette' },
        { l: 'Victor', u: '/collections/raquettes-de-badminton/Victor+Raquette' },
        { l: 'Li-Ning', u: '/collections/raquettes-de-badminton/LI-NING+Raquette' },
        { l: 'Babolat', u: '/collections/raquettes-de-badminton/Babolat+Raquette' },
        { l: 'Felet', u: '/collections/raquettes-de-badminton/Felet+Raquette' },
        { l: 'Karakal', u: '/collections/raquettes-de-badminton/KARAKAL+raquette' },
        { l: 'Fz Forza', u: '/collections/raquettes-de-badminton/Fz-Forza+Raquette' },
        { l: 'Young', u: '/collections/raquettes-de-badminton/Young+Raquette' },
        { l: 'Apacs', u: '/collections/raquettes-de-badminton/Apacs+raquettes' },
        { l: 'Maxbolt', u: '/collections/collection-maxbolt/Raquette' },
        { l: 'Tester une raquette', u: '/collections/testez-des-raquettes-de-tennis-et-badminton/TEST-BADMINTON' }
      ]}
    ]},
    { l: 'CHAUSSURES', u: '/collections/chaussures-de-badminton-pour-tous-les-niveaux', groups: [
      { links: [
        { l: 'Homme', u: '/collections/chaussures-de-badminton-pour-tous-les-niveaux/Chaussure-homme+badminton' },
        { l: 'Femme', u: '/collections/chaussures-de-badminton-pour-tous-les-niveaux/Chaussures-femmes+badminton' },
        { l: 'Junior', u: '/collections/chaussures-de-badminton-pour-tous-les-niveaux/Chaussure-junior+badminton' }
      ]}
    ]},
    { l: 'VOLANTS', u: '/collections/volants-de-badminton', groups: [
      { links: [
        { l: 'Plumes', u: '/collections/volants-de-badminton/Plume' },
        { l: 'Plastiques', u: '/collections/volants-de-badminton/plastique' },
        { l: 'Hybrid', u: '/collections/volants-de-badminton/hybrid' }
      ]}
    ]},
    { l: 'TEXTILE', u: '/collections/vetements-de-badminton', groups: [
      { t: 'HOMME', tu: '/collections/vetements-de-badminton/Homme', links: [
        { l: 'Maillot', u: '/collections/vetements-de-badminton/Homme+Maillot' },
        { l: 'Short', u: '/collections/vetements-de-badminton/Short+Homme' },
        { l: 'Sweat', u: '/collections/vetements-de-badminton/Sweat+Homme' },
        { l: 'Pantalon', u: '/collections/vetements-de-badminton/Pantalon+Homme' },
        { l: 'Veste', u: '/collections/vetements-de-badminton/Veste+Homme' }
      ]},
      { t: 'FEMME', tu: '/collections/vetements-de-badminton/Femme', links: [
        { l: 'Maillots', u: '/collections/vetements-de-badminton/Maillot+Femme' },
        { l: 'Jupe', u: '/collections/vetements-de-badminton/Jupe+Femme' },
        { l: 'Short', u: '/collections/vetements-de-badminton/Short+Femme' },
        { l: 'Sweat', u: '/collections/vetements-de-badminton/Sweat+Femme' },
        { l: 'Pantalon', u: '/collections/vetements-de-badminton/Pantalon+Femme' },
        { l: 'Veste', u: '/collections/vetements-de-badminton/Veste+Femme' }
      ]},
      { t: 'JUNIOR', tu: '/collections/vetements-de-badminton/Junior', links: [
        { l: 'Maillot', u: '/collections/vetements-de-badminton/Maillot+Junior' },
        { l: 'Short', u: '/collections/vetements-de-badminton/Short+Junior' },
        { l: 'Jupe', u: '/collections/vetements-de-badminton/Jupe+Junior' },
        { l: 'Pantalon', u: '/collections/vetements-de-badminton/Pantalon+Junior' },
        { l: 'Veste', u: '/collections/vetements-de-badminton/Veste+Junior' }
      ]},
      { links: [ { l: 'Chaussettes', u: '/collections/vetements-de-badminton/Chaussette' } ] }
    ]},
    { l: 'SACS', u: '/collections/sacs-badminton', groups: [
      { links: [
        { l: 'Sac à dos', u: '/collections/sacs-badminton/Sac-%C3%A0-dos' },
        { l: 'Sac une poche', u: '/collections/sacs-badminton/simple' },
        { l: 'Sac double poches', u: '/collections/sacs-badminton/Double' },
        { l: 'Sac triple poches', u: '/collections/sacs-badminton/triple' }
      ]}
    ]},
    { l: 'ACCESSOIRES', u: '/collections/accessoires-de-badminton-grips-surgrips-poignets', groups: [
      { t: 'CORDAGE', links: [
        { l: 'Bobines', u: '/collections/accessoires/Bobine-200m' },
        { l: 'Garniture', u: '/collections/accessoires/Garniture' }
      ]},
      { t: 'GRIPS / SURGRIPS', links: [
        { l: 'Grips', u: '/collections/accessoires/Grips' },
        { l: 'Surgrips', u: '/collections/accessoires/Surgrips' }
      ]},
      { links: [
        { l: 'Claquette', u: '/collections/accessoires/claquette' },
        { l: 'Poignet / Bandeau', u: '/collections/accessoires/Poignet+bandeau' },
        { l: 'Massage', u: '/collections/accessoires/Foam-Roller' },
        { l: 'Semelles', u: '/collections/accessoires/Semelles' },
        { l: 'Manchon', u: '/collections/accessoires/Manchon' },
        { l: 'Filet', u: '/collections/accessoires/Filet' },
        { l: 'Gourde', u: '/collections/accessoires/Gourde' }
      ]}
    ]},
    { l: 'CORDAGE', u: '/pages/nos-cordages-badminton', groups: [
      { t: 'SERVICE CORDAGE', links: [
        { l: 'Badminton', u: '/pages/nos-cordages-badminton' },
        { l: 'Tennis', u: '/pages/nos-cordages-tennis' },
        { l: 'Squash', u: '/pages/nos-cordages-squash' }
      ]}
    ]},
    { l: 'CLUBS', u: '/pages/clubs-partenaires', groups: [
      { links: [
        { l: 'Partenaires', u: '/pages/clubs-partenaires' },
        { l: 'Matériel club', u: '/collections/materiel-club' },
        { l: 'Textile club', u: '/collections/vetements-de-badminton/Club' },
        { l: 'Poteaux', u: '/collections/materiel-club/Poteaux' },
        { l: 'Catalogue club', u: '/pages/catalogue-club-badminton' }
      ]}
    ]},
    { l: 'PERSONNALISATION', u: '/pages/sublimation', groups: [
      { links: [
        { l: 'Flocage personnalisé', u: '/products/flocage-personnalise' },
        { l: 'Sublimation', u: '/pages/sublimation' },
        { l: 'Bon cadeau', u: '/products/carte-cadeau-dc-sports' }
      ]}
    ]},
    { l: 'DÉSTOCKAGE', u: '/collections/promotions-badminton-et-sports-dequipe', groups: [
      { t: 'TEXTILE', links: [
        { l: 'Homme', u: '/collections/vetements-de-badminton/destockage+Homme' },
        { l: 'Femme', u: '/collections/vetements-de-badminton/destockage+Femme' },
        { l: 'Junior', u: '/collections/vetements-de-badminton/destockage+Junior' }
      ]},
      { t: 'RAQUETTES', links: [
        { l: 'Yonex', u: '/collections/raquettes-de-badminton/Yonex+Raquette+destockage' },
        { l: 'Victor', u: '/collections/raquettes-de-badminton/Victor+Raquette+destockage' },
        { l: 'Babolat', u: '/collections/raquettes-de-badminton/Babolat+Raquette+destockage' },
        { l: 'Li-Ning', u: '/collections/raquettes-de-badminton/LI-NING+Raquette+destockage' }
      ]},
      { t: 'CHAUSSURES', links: [
        { l: 'Femme', u: '/collections/promotions-badminton-et-sports-dequipe/Chaussures-femmes+badminton+destockage' },
        { l: 'Homme', u: '/collections/promotions-badminton-et-sports-dequipe/Chaussure-homme+badminton+destockage' }
      ]}
    ]},
    { l: 'CONSEILS & GUIDES', u: '/blogs/conseils-badminton', groups: [] },
    { l: 'CONTACT', u: '/pages/contactez-nous', groups: [] }
  ];

  var QUICK = [
    { l: 'Raquettes', u: '/collections/raquettes-de-badminton' },
    { l: 'Chaussures', u: '/collections/chaussures-de-badminton-pour-tous-les-niveaux' },
    { l: 'Volants', u: '/collections/volants-de-badminton' },
    { l: 'Textile', u: '/collections/vetements-de-badminton' },
    { l: 'Sacs', u: '/collections/sacs-badminton' },
    { l: 'Accessoires', u: '/collections/accessoires-de-badminton-grips-surgrips-poignets' },
    { l: 'Déstockage', u: '/collections/promotions-badminton-et-sports-dequipe' }
  ];

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s){ return (s+'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function parseDynamicMenu(){
    try{
      var node=document.getElementById('dc-menu-data');
      if(!node) return null;
      var raw=(node.textContent||'').replace(/,(\s*[}\]])/g,'$1').replace(/,(\s*[}\]])/g,'$1');
      var data=JSON.parse(raw);
      if(data && data.length) return data;
    }catch(e){}
    return null;
  }
  function buildMenu() {
    if (document.getElementById('dcmOverlay')) return;

    /* ----- Barre déclencheur (sous le header) ----- */
    var bar = el('div', 'dcm-bar');
    var inner = el('div', 'dcm-bar-inner');
    var trigger = el('button', 'dcm-trigger');
    trigger.type = 'button';
    trigger.innerHTML = '<span class="dcm-burger"><i></i><i></i><i></i></span><span>MENU</span>';
    var chips = el('div', 'dcm-chips');
    QUICK.forEach(function (q) {
      var a = el('a', 'dcm-chip', esc(q.l)); a.href = q.u; chips.appendChild(a);
    });
    inner.appendChild(trigger); inner.appendChild(chips);
    bar.appendChild(inner);

    /* ----- Overlay plein écran ----- */
    var ov = el('div', 'dcm-overlay'); ov.id = 'dcmOverlay'; ov.setAttribute('aria-hidden', 'true');
    var head = el('div', 'dcm-head');
    head.innerHTML = '<span class="dcm-wordmark">DC<b>.</b>SPORTS</span>';
    var closeBtn = el('button', 'dcm-close', '&times;'); closeBtn.type = 'button'; closeBtn.setAttribute('aria-label', 'Fermer');
    head.appendChild(closeBtn);

    var body = el('div', 'dcm-body');
    var list = el('div', 'dcm-list');
    var MENU_DATA = parseDynamicMenu() || MENU;
    MENU_DATA.forEach(function (cat, i) {
      var item = el('div', 'dcm-cat');
      var hasPanel = cat.groups && cat.groups.length;
      var headRow = el('div', 'dcm-cat-head');
      var idx = ('0' + (i + 1)).slice(-2);
      headRow.innerHTML = '<span class="dcm-idx">' + idx + '</span><a class="dcm-cat-link" href="' + cat.u + '">' + esc(cat.l) + '</a>';
      if (hasPanel) {
        var toggle = el('button', 'dcm-toggle', '<span></span><span></span>'); toggle.type = 'button'; toggle.setAttribute('aria-label', 'Ouvrir ' + cat.l);
        headRow.appendChild(toggle);
      }
      item.appendChild(headRow);

      if (hasPanel) {
        var panel = el('div', 'dcm-panel');
        var cols = el('div', 'dcm-cols');
        cat.groups.forEach(function (g) {
          var col = el('div', 'dcm-col');
          if (g.t) {
            if (g.tu) col.appendChild((function(){var a=el('a','dcm-col-title',esc(g.t));a.href=g.tu;return a;})());
            else col.appendChild(el('div', 'dcm-col-title', esc(g.t)));
          }
          var ul = el('ul', 'dcm-links');
          (g.links || []).forEach(function (lk) {
            var li = el('li'); var a = el('a', null, esc(lk.l)); a.href = lk.u; li.appendChild(a); ul.appendChild(li);
          });
          col.appendChild(ul); cols.appendChild(col);
        });
        panel.appendChild(cols);
        item.appendChild(panel);

        var openThis = function () {
          var isOpen = item.classList.contains('is-open');
          list.querySelectorAll('.dcm-cat.is-open').forEach(function (x) { if (x !== item) { x.classList.remove('is-open'); var p = x.querySelector('.dcm-panel'); if (p) p.style.maxHeight = ''; } });
          if (isOpen) { item.classList.remove('is-open'); panel.style.maxHeight = ''; }
          else { item.classList.add('is-open'); panel.style.maxHeight = panel.scrollHeight + 'px'; }
        };
        headRow.querySelector('.dcm-toggle').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openThis(); });
      }
      list.appendChild(item);
    });
    var dcLogged = document.body.classList.contains('customer-logged-in');
    var acct = el('a','dcm-account','<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5zm0 2c-4 0-9 2-9 6v1h18v-1c0-4-5-6-9-6z"/></svg><span>'+(dcLogged?'Mon compte':'Se connecter / Créer un compte')+'</span>');
    acct.href = dcLogged ? 'https://shopify.com/35861332012/account/profile' : '/account/login';
    body.appendChild(acct);
    body.appendChild(list);

    var foot = el('div', 'dcm-foot');
    foot.innerHTML =
      '<a href="https://shopify.com/35861332012/account/profile">Mon compte</a>' +
      '<a href="/pages/contactez-nous">Contact</a>' +
      '<a href="/blogs/conseils-badminton">Conseils &amp; guides</a>' +
      '<a href="/pages/magasin">Notre magasin</a>';

    var drawer = el('div', 'dcm-drawer'); drawer.appendChild(head); drawer.appendChild(body); drawer.appendChild(foot); ov.appendChild(drawer);

    /* ----- Insertion dans la page ----- */
    var header = document.getElementById('shopify-section-header') || document.querySelector('.cont-header');
    if (header && header.parentNode) {
      if (header.id === 'shopify-section-header') header.insertAdjacentElement('afterend', bar);
      else header.appendChild(bar);
    } else {
      document.body.insertBefore(bar, document.body.firstChild);
    }
    document.body.appendChild(ov);
    document.body.classList.add('dcm-ready');

    /* ----- Ouverture / fermeture ----- */
    var open = function () { ov.classList.add('is-open'); ov.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
    var close = function () { ov.classList.remove('is-open'); ov.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
    trigger.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ====== Reveal doux des en-têtes de section ====== */
  function reveals() {
    try {
      var targets = [].slice.call(document.querySelectorAll('.section-header'));
      if (!('IntersectionObserver' in window) || !targets.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('dc-in'); io.unobserve(en.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      targets.forEach(function (el2) { el2.classList.add('dc-reveal'); io.observe(el2); });
      setTimeout(function () { targets.forEach(function (el2) { el2.classList.add('dc-in'); }); }, 1500);
    } catch (e) {}
  }

  function rollPayments(){
    try{
      var box=document.querySelector('.payment_methods');
      if(!box || box.getAttribute('data-dc-roll')) return;
      var imgs=Array.prototype.slice.call(box.children);
      if(imgs.length<2) return;
      box.setAttribute('data-dc-roll','1');
      var track=document.createElement('div'); track.className='dc-pay-track';
      imgs.forEach(function(n){ track.appendChild(n); });
      imgs.forEach(function(n){ track.appendChild(n.cloneNode(true)); });
      box.appendChild(track);
      box.classList.add('dc-pay-roll');
    }catch(e){}
  }
  function fixTiktok(){
    try{
      var links=document.querySelectorAll('a[href*="tiktok"]');
      links.forEach(function(a){
        var svg=a.querySelector('svg');
        if(!svg) return;
        svg.setAttribute('viewBox','0 0 24 24');
        svg.setAttribute('width','18'); svg.setAttribute('height','18');
        svg.innerHTML='<path fill="#ffffff" d="M16.5 2c.32 2.13 1.64 3.62 3.5 3.9v2.83c-1.3.06-2.49-.27-3.6-.95v6.42a5.74 5.74 0 1 1-5.74-5.74c.31 0 .62.02.92.07v2.94a2.83 2.83 0 1 0 1.98 2.7V2z"/>';
        svg.style.fill='#ffffff'; svg.style.overflow='visible';
        a.style.position='relative'; a.style.zIndex='2';
      });
    }catch(e){}
  }
  function rollProductPayImg(){
    try{
      var img=document.querySelector('img[src*="ssss"]');
      if(!img || img.closest('footer,.site-footer')) return;
      if(img.getAttribute('data-dc-payimg')) return;
      img.setAttribute('data-dc-payimg','1');
      var wrap=document.createElement('div'); wrap.className='dc-payimg-roll';
      var track=document.createElement('div'); track.className='dc-payimg-track';
      img.parentNode.insertBefore(wrap, img);
      track.appendChild(img);
      var clone=img.cloneNode(true);
      if(!clone.getAttribute('src') && img.currentSrc){ clone.setAttribute('src', img.currentSrc); }
      clone.removeAttribute('data-dc-payimg');
      track.appendChild(clone);
      wrap.appendChild(track);
    }catch(e){}
  }
  function addEquilibreZone(){
    try{
      var wraps=document.querySelectorAll('.bar-wrapper');
      Array.prototype.forEach.call(wraps,function(wrap){
        var lab=wrap.querySelector('.bar-main-label'); if(!lab) return;
        var name=(lab.textContent||'').toLowerCase();
        var fg=wrap.querySelector('.bar-fg'); var bv=wrap.querySelector('.bar-value');
        if(!fg||!bv) return;
        var v=parseFloat(fg.getAttribute('data-value')); if(isNaN(v)) return;
        var zone=null;
        if(/quilibre/.test(name)){ zone = v<40 ? 'En-manche' : (v<=55 ? 'Neutre' : 'En-tête'); }
        else if(/flexib/.test(name)){ zone = v<45 ? 'Souple' : (v<=60 ? 'Semi-rigide' : 'Rigide'); }
        if(!zone) return;
        function ensure(){ if(!bv.querySelector('.dc-eq-zone')){ var s=document.createElement('span'); s.className='dc-eq-zone'; s.innerHTML=' <strong>'+zone+'</strong>'; bv.appendChild(s);} }
        ensure();
        try{ var mo=new MutationObserver(function(){ ensure(); }); mo.observe(bv,{childList:true,characterData:true,subtree:true}); }catch(e){}
      });
    }catch(e){}
  }
  function addDonutToggle(){
    try{
      var bars=document.querySelectorAll('.bar-wrapper');
      if(!bars.length) return;
      var parent=bars[0].parentNode;
      if(!parent || parent.getAttribute('data-dc-dt')) return;
      parent.setAttribute('data-dc-dt','1');
      var holder=document.createElement('div'); holder.className='dc-donut-body dc-collapsed';
      parent.insertBefore(holder, bars[0]);
      Array.prototype.forEach.call(bars,function(b){ holder.appendChild(b); });
      var btn=document.createElement('button'); btn.type='button'; btn.className='dc-donut-toggle'; btn.setAttribute('aria-expanded','false');
      btn.innerHTML='<span class="dc-dt-label">Voir les caractéristiques de la raquette</span><span class="dc-dt-caret">▾</span>';
      parent.insertBefore(btn, holder);
      btn.addEventListener('click', function(){
        var open = holder.classList.toggle('dc-collapsed')===false;
        btn.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open?'true':'false');
        btn.querySelector('.dc-dt-label').textContent = open ? 'Masquer les caractéristiques' : 'Voir les caractéristiques de la raquette';
      });
    }catch(e){}
  }
  /* ====== Facture PDF téléchargeable sur la page commande client ====== */
  var DC_SHOP = {
    name:'DC.SPORTS',
    lines:['47 Boulevard de la Gribelette','91390 Morsang-sur-Orge, France','Tél. 01 88 93 69 16','david@dcsports.fr  ·  dcsports.fr','SIRET 898 924 147 00017  ·  TVA FR84898924147']
  };
  function dcTxt(e){ return e ? (e.textContent||'').replace(/\s+/g,' ').trim() : ''; }
  function loadJsPDF(cb){
    if(window.jspdf && window.jspdf.jsPDF){ cb(); return; }
    var s=document.createElement('script');
    s.src='https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
    s.onload=function(){ cb(); };
    s.onerror=function(){ alert('Impossible de charger le générateur de PDF. Réessayez.'); };
    document.head.appendChild(s);
  }
  function readOrder(){
    var table=document.querySelector('.wrapper table.full'); if(!table) return null;
    var data={ number:'', date:'', items:[], totals:[], blocks:[] };
    var pageTxt=dcTxt(document.querySelector('.wrapper'));
    var mNum=pageTxt.match(/#\s?[A-Za-z0-9._-]+/); if(mNum) data.number=mNum[0].replace(/\s/g,'');
    var firstStrong=document.querySelector('.wrapper h1 ~ * strong, .wrapper h2 ~ p strong, .wrapper p strong');
    if(firstStrong) data.date=dcTxt(firstStrong);
    table.querySelectorAll('tbody tr').forEach(function(tr){
      var td=tr.querySelectorAll('td'); if(td.length<5) return;
      var a=td[0].querySelector('a');
      data.items.push({ title:a?dcTxt(a):dcTxt(td[0]), sku:dcTxt(td[1]), price:dcTxt(td[2]), qty:dcTxt(td[3]), total:dcTxt(td[4]) });
    });
    table.querySelectorAll('tfoot tr').forEach(function(tr){
      var l=tr.querySelector('td'); var v=tr.querySelector('td.text-right');
      if(l&&v) data.totals.push({ l:dcTxt(l).replace(/:\s*$/,''), v:dcTxt(v), strong:!!tr.querySelector('strong') });
    });
    var cols=document.querySelectorAll('.wrapper .grid > div');
    var addrCol=cols.length?cols[cols.length-1]:null;
    if(addrCol){
      var heads=addrCol.querySelectorAll('h2');
      heads.forEach(function(h){
        var blk={ title:dcTxt(h), lines:[] };
        var n=h.nextElementSibling;
        while(n && n.tagName!=='H2' && n.tagName!=='HR'){
          if(n.tagName==='H3'||n.tagName==='P'){
            var t=(n.innerText||n.textContent||'').replace(/ /g,' ');
            t.split(/\n|<br\s*\/?>/).forEach(function(p){ p=p.replace(/\s+/g,' ').trim(); if(p) blk.lines.push(p); });
          }
          n=n.nextElementSibling;
        }
        if(blk.lines.length) data.blocks.push(blk);
      });
    }
    return data;
  }
  function generateInvoice(){
    var d=readOrder();
    if(!d || !d.items.length){ alert('Données de commande introuvables.'); return; }
    loadJsPDF(function(){
      try{
        var jsPDF=window.jspdf.jsPDF;
        var doc=new jsPDF({unit:'pt',format:'a4'});
        var W=doc.internal.pageSize.getWidth(), H=doc.internal.pageSize.getHeight();
        var M=42, y=54, RED=[226,0,26], INK=[16,16,20], GREY=[120,120,128];
        doc.setFont('helvetica','bold'); doc.setFontSize(20); doc.setTextColor(RED[0],RED[1],RED[2]);
        doc.text(DC_SHOP.name, M, y);
        doc.setFont('helvetica','normal'); doc.setFontSize(9); doc.setTextColor(GREY[0],GREY[1],GREY[2]);
        var yy=y+16; DC_SHOP.lines.forEach(function(l){ doc.text(l, M, yy); yy+=12; });
        doc.setFont('helvetica','bold'); doc.setFontSize(18); doc.setTextColor(INK[0],INK[1],INK[2]);
        doc.text('FACTURE', W-M, y, {align:'right'});
        doc.setFont('helvetica','normal'); doc.setFontSize(10); doc.setTextColor(60,60,66);
        var ry=y+16;
        if(d.number){ doc.text('Commande '+d.number, W-M, ry, {align:'right'}); ry+=13; }
        if(d.date){ doc.text(d.date, W-M, ry, {align:'right'}); ry+=13; }
        y=Math.max(yy,ry)+10;
        doc.setDrawColor(225,225,229); doc.setLineWidth(1); doc.line(M,y,W-M,y); y+=22;
        var colW=(W-M*2-20)/2, startY=y, maxBlockY=y;
        d.blocks.slice(0,2).forEach(function(blk,i){
          var bx=M+i*(colW+20), by=startY;
          doc.setFont('helvetica','bold'); doc.setFontSize(9.5); doc.setTextColor(INK[0],INK[1],INK[2]);
          doc.text((blk.title||'').toUpperCase(), bx, by); by+=14;
          doc.setFont('helvetica','normal'); doc.setFontSize(9.5); doc.setTextColor(60,60,66);
          blk.lines.forEach(function(l){ var w=doc.splitTextToSize(l,colW); w.forEach(function(ln){ doc.text(ln,bx,by); by+=12; }); });
          if(by>maxBlockY) maxBlockY=by;
        });
        y=maxBlockY+18;
        var cTitle=M, cSku=M+248, cPrice=M+330, cQty=M+392, cTot=W-M;
        function tableHead(){
          doc.setFillColor(INK[0],INK[1],INK[2]); doc.rect(M,y-12,W-M*2,22,'F');
          doc.setFont('helvetica','bold'); doc.setFontSize(9); doc.setTextColor(255,255,255);
          doc.text('PRODUIT',cTitle+6,y+3);
          doc.text('RÉF.',cSku,y+3);
          doc.text('P.U.',cPrice,y+3,{align:'right'});
          doc.text('QTÉ',cQty,y+3,{align:'right'});
          doc.text('TOTAL',cTot-6,y+3,{align:'right'});
          y+=22;
        }
        tableHead();
        doc.setFont('helvetica','normal'); doc.setFontSize(9); doc.setTextColor(40,40,46);
        d.items.forEach(function(it){
          var titleLines=doc.splitTextToSize(it.title, 232);
          var rowH=Math.max(16, titleLines.length*11+6);
          if(y+rowH>H-90){ doc.addPage(); y=60; tableHead(); doc.setFont('helvetica','normal'); doc.setFontSize(9); doc.setTextColor(40,40,46); }
          var ty=y+3;
          titleLines.forEach(function(ln,k){ doc.text(ln,cTitle+6,ty+k*11); });
          doc.setTextColor(120,120,128); doc.text(it.sku||'—',cSku,ty); doc.setTextColor(40,40,46);
          doc.text(it.price,cPrice,ty,{align:'right'});
          doc.text(it.qty,cQty,ty,{align:'right'});
          doc.text(it.total,cTot-6,ty,{align:'right'});
          y+=rowH;
          doc.setDrawColor(238,238,241); doc.setLineWidth(.5); doc.line(M,y-4,W-M,y-4);
        });
        y+=14;
        d.totals.forEach(function(t){
          if(y>H-70){ doc.addPage(); y=60; }
          doc.setFont('helvetica',t.strong?'bold':'normal'); doc.setFontSize(t.strong?11:9.5);
          doc.setTextColor(t.strong?INK[0]:90, t.strong?INK[1]:90, t.strong?INK[2]:96);
          doc.text(t.l, cPrice-40, y, {align:'right'});
          doc.text(t.v, cTot-6, y, {align:'right'});
          y+=t.strong?17:14;
        });
        doc.setFont('helvetica','normal'); doc.setFontSize(8.5); doc.setTextColor(150,150,156);
        doc.text('Merci pour votre commande — DC.Sports, spécialiste badminton.', M, H-46);
        doc.text('Document généré depuis votre espace client. Pour toute question : david@dcsports.fr', M, H-34);
        doc.save('Facture-DCSports'+(d.number?'-'+d.number.replace(/[^A-Za-z0-9]/g,''):'')+'.pdf');
      }catch(e){ alert('Erreur lors de la génération du PDF.'); }
    });
  }
  function addInvoiceButton(){
    try{
      if(!/\/orders?\//.test(location.pathname.toLowerCase())) return;
      var table=document.querySelector('.wrapper table.full'); if(!table) return;
      if(document.querySelector('.dc-invoice-btn')) return;
      var anchor=document.querySelector('.wrapper h1') || table;
      var btn=document.createElement('button');
      btn.type='button'; btn.className='dc-invoice-btn';
      btn.innerHTML='<span class="dc-inv-ico" aria-hidden="true">⤓</span> Télécharger ma facture (PDF)';
      btn.addEventListener('click', generateInvoice);
      var holder=document.createElement('div'); holder.className='dc-invoice-wrap'; holder.appendChild(btn);
      anchor.insertAdjacentElement('afterend', holder);
    }catch(e){}
  }
  function hideVifyButton(){
    try{
      var run=function(){
        var els=document.querySelectorAll('a,button,[role="button"],input[type="submit"],input[type="button"]');
        Array.prototype.forEach.call(els,function(e){
          if(e.classList && e.classList.contains('dc-invoice-btn')) return;
          var t=((e.textContent||'')+' '+(e.value||'')).trim().toLowerCase();
          if(t.indexOf('download pdf invoice')>-1){
            var box=e.closest('[class*="vify"],[id*="vify"]') || e;
            box.style.display='none';
          }
        });
      };
      run();
      var n=0, iv=setInterval(function(){ run(); if(++n>12) clearInterval(iv); }, 500);
    }catch(e){}
  }
  function init() { try { buildMenu(); } catch (e) {} reveals(); try { rollPayments(); } catch(e){} try { fixTiktok(); } catch(e){} try { rollProductPayImg(); } catch(e){} try { addEquilibreZone(); } catch(e){} try { addDonutToggle(); } catch(e){} try { addInvoiceButton(); } catch(e){} try { hideVifyButton(); } catch(e){} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
